'use es6';

import { List } from 'immutable';
import { createSelector } from 'reselect';
export const getAvailableLanguages = state => state.availableLanguages;
const getByTrackId = createSelector(getAvailableLanguages, availableLanguages => {
  return availableLanguages.get('byTrackId');
});
export const availableLanuguagesByTrackId = createSelector(getByTrackId, (state, props) => props.trackId, (byTrackId, trackId) => {
  const languages = byTrackId.get(trackId.toString());
  return languages && List(languages);
});
const getByLessonId = createSelector(getAvailableLanguages, availableLanguages => {
  return availableLanguages.get('byLessonId');
});
export const availableLanuguagesByLessonId = createSelector(getByLessonId, (state, props) => props.lessonId, (byLessonId, lessonId) => byLessonId.get(lessonId));